<template>
  <div>
    <div class="row text-white inner-row" style="background: #44927b">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b> {{object.name}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>
    <simple-row :name="'Наименование'" :value="fieldView(object.name)"></simple-row>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       object: this.item.object,
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     }
   }
 }
</script>
<style>
</style>
